module.exports = __webpack_public_path__ + "static/bg4.380966f6.png";